export default function CsharpTextTypes() {
  return (
    <h2>Csharp Text Types</h2>
  );
}
